import PatientsList from "./patientsLists/patientsList";
import React, {useEffect, useRef, useState} from 'react';
import BookedAdmissionsHeader from "./header/bookedAdmissionsHeader";
import AdmissionContent from './content/content';
import Worklist from "./worklist/worklist";
import {
    setNewStartDay,
    reload,
    getAdmissionConfig,
    getConfig,
    getTheatres,
    getOperationsStatus,
    setMarkedOperation,
    getAdmissionType,
    getHourHeight,
    getStartDay,
    setHourHeight,
    getSpecialties,
    setAllTheatersDict,
    setDefaultFilterToMe,
    getSession,
    getInitRenderCalendar,
    setInitRenderCalendar, setNewAdmissionType,
} from '../../store/reducers/booked_admissions';
import {useDispatch, useSelector} from "react-redux";
import moment from "moment";
import API from "../../app/api";
import {admissionDnD, setAdmissionDnD} from "../../store/reducers/dragAndDrop";
import $ from "jquery";
import WorkList, {proceduresLen} from '../bookAdmission/workList';
import _ from 'lodash';
import {agylePref} from '../../store/reducers/preferences';
import makeStyles from '@mui/styles/makeStyles';
import AgyleTextField from '../../components/ui/fields/agyleTextField';
import FormLabel from '@mui/material/FormLabel';
import FormControl from '@mui/material/FormControl';
import AgyleDialog from '../../components/modal/agyleDialog';
import {ProcedureItem} from '../bookAdmission/proceduresSection';
import useOpenState from '../../hooks/useOpenState';
import {useStylesInputControls} from '../bookAdmission/createBookAdmissionForm';
import AgyleButton from '../../components/ui/buttons/agyleButton';
import {setSnackbar} from '../../store/reducers/globals';
import {useHistory, useLocation} from "react-router-dom";
import {hasPermission, Permissions, user} from '../../store/reducers/user';
import {isCentralPageModuleEnabled} from '../centralPage/helper';

export const admissionViewTypes = {
    MDU: "MDU",
    THEATRES: "TCI"
}
export const admissionStatusTypes = {
    WORKLIST: "Worklist",
    UNSCHEDULED: "Unscheduled",
    SCHEDULED: "Scheduled"
}
export const SessionsTime = {
    AM: "am",
    PM: "pm",
    TW: "twighlight",
    AD: "all"
}
export const CalendarViews = {
    days1: "days1",
    days4: "days4",
    days5: "days5",
    days7: "days7",
    month: "month"
}

export const bookAdmissionToggleStyles = makeStyles((theme) => ({
    baToggle_classNameRoot: {
        color: theme.palette.mode === "dark" ? "black" : "#f3f3f4",
        backgroundColor: theme.palette.mode === "dark" ? "#313233" : "#bfc2c7",
       // padding: 3
        display: "inline-block"
    },
    baToggle_classNameRootSecond: {
        color: theme.palette.mode === "dark" ? "black" : "#f3f3f4",
        backgroundColor: theme.palette.mode === "dark" ? "#252525" : "#bfc2c7",
        // padding: 3
    },
    baToggle_classNameLabel: {
        color: theme.palette.mode === "dark" ? "#ACAFB3" : "#f3f3f4",
        "&.Mui-disabled": {
            border: "none",
        }
    },
    baToggle_classNameSelected: {
        color: theme.palette.mode === "dark" ? "black !important" : "#ffffff !important",
        fontWeight: theme.palette.mode === "dark" ? 400 : 600,
        backgroundColor: theme.palette.mode === "dark" ? "#ffffff !important" : "#626466 !important"
    },
    baButton_classNamePrimary: {
        backgroundColor: "#2280f7",
        "&:hover": {
            backgroundColor: "#303f9f",
        }
    },
    baButton_classNameSecondary: {
        color: "#626466",
        backgroundColor: "#bfc2c7",
        "&:hover": {
            color: "#282828",
            backgroundColor: "#9b9b9b",
        }
    }
}))

const BookedAdmissions = (props) => {
    const dispatch = useDispatch();
    const admissionItemDnD = useSelector(admissionDnD);
    const sessionDragOver = useRef(null);
    const sessionDragOverTmp = useRef(null);
    const admissionStatus = useSelector(getOperationsStatus);
    const admissionType = useSelector(getAdmissionType);
    const hourHeight = useSelector(getHourHeight);
    const startDay = useSelector(getStartDay);
    const config = useSelector(getConfig);
    const history = useHistory();
    const location = useLocation();
    const agylePreference = useSelector(agylePref);
    const userObject = useSelector(user);

    const [initConsultantFilter, setInitConsultantFilter] = useState(true);

    useEffect(()=>{
        if(!_.isEmpty(userObject) && !dispatch(hasPermission(Permissions.BA_CAN_ACCESS_BA))){
            history.push("/");
        }
    },[userObject]);

    useEffect(() => {
        if(!startDay) dispatch(setNewStartDay(moment().startOf('month')));
        dispatch(getAdmissionConfig());
        //dispatch(getTheatres());
        history.push(location.href, null);

    },[])


    useEffect(()=>{
        history.push(location.href, null);
        if (agylePreference?.bookedAdmissions?.view === "no_expand") {
            dispatch(setHourHeight(70));
        } else if (agylePreference?.bookedAdmissions?.view) {
            dispatch(setHourHeight(400));
        } else if (config?.viewDef === "no_expand") {
            dispatch(setHourHeight(70));
        } else if (config?.viewDef) {
            dispatch(setHourHeight(400));
        }

        if(admissionType === null && config && agylePreference?.bookedAdmissions){
            if(agylePreference?.bookedAdmissions?.defaultCalendarAdmissionType) {
                dispatch(setNewAdmissionType(agylePreference?.bookedAdmissions?.defaultCalendarAdmissionType?.code));
            } else if(config.defaultCalendarAdmissionType) {
                dispatch(setNewAdmissionType(config.defaultCalendarAdmissionType.code));
            } else {
                dispatch(setNewAdmissionType(admissionViewTypes.THEATRES));
            }

        }

    },[agylePreference, config])


    const initRender = useSelector(getInitRenderCalendar);

    useEffect(()=>{
        if(initRender && agylePreference?.bookedAdmissions?.defaultConsultantToMe && userObject?.userName){
            dispatch(setDefaultFilterToMe(userObject.userName));
            setInitConsultantFilter(false);
            dispatch(setInitRenderCalendar(false));
        }

    }, [agylePreference, userObject]);


    const prevDefault = (e) => {
        if(admissionItemDnD)
            e.preventDefault();
    };


    const  getOffsetPosition = (event, parent) => {
        var bounds = parent.getBoundingClientRect();
        var x = event.clientX - bounds.left;
        var y = event.clientY - bounds.top;
        return {x: x, y: y};
    }

    const setGhost = (type, event) => {
        const elements = document.elementsFromPoint(event.pageX, event.pageY);
        const firstFilterContainer = Array.from(elements).filter(el => el.id.startsWith(type))[0];
        const filterCard = Array.from(elements).filter(el => el.id.startsWith("card_"));
        const ghost = $("#dandd");
        const ghostTime = $("#dandd_2");

        if(Array.from(elements).filter(el => el.id.startsWith("holding")).length !== 0) {
            const holdingContainer = Array.from(elements).filter(el => el.id.startsWith("holding"))[0];
            let containerId = holdingContainer.id.split("_");

            let minutesToAdd = Math.floor(ghost.height() * 60 / hourHeight);
            let session = dispatch(getSession(containerId[1]));

            let time = 0;
            session.bookedSessions?.forEach((item)=> {
                time += item.timeLen
            })

            let sessionIsFull = session.maxTime - time - minutesToAdd < 0

            if(sessionIsFull) {
                ghostTime.html("Session Full");
                sessionDragOver.current = null;
            } else {
                ghostTime.html("HOLDING");
                sessionDragOver.current = {
                    id: containerId[1],
                    holdingPen: true
                };

                ghost.css("opacity", 1);
            }

        }

        else if (firstFilterContainer && filterCard.length === 0) {

            let top = getOffsetPosition(event, firstFilterContainer).y; //event.offsetY;
            let bottom = top + ghost.height();
            let minutes = Math.floor(top * 60 / hourHeight);
            let containerId = firstFilterContainer.id.split("_");
            let timeMoment = moment.utc(containerId[1], "DD-MM-YYYY-HH-mm");
            let time = timeMoment.add(minutes, "minutes");
            let isFree = true;

                const filterChildren = Array.from(firstFilterContainer.children).filter(el => !el.id.startsWith("available_slot") && !el.id.startsWith("holding"));

                if (firstFilterContainer.offsetHeight > bottom && firstFilterContainer.offsetTop < top) {
                    const children = filterChildren;
                    isFree = children.every(c => bottom <= c.offsetTop || top >= c.offsetTop + c.offsetHeight + 1);
                } else {
                    isFree = false;
                }

                if(admissionItemDnD.item.bookedSession && containerId[2] !== admissionItemDnD.item.bookedSession) {
                    isFree = false;
                }



                if (isFree) {
                    ghostTime.html(time.local().format("HH:mm"));

                    sessionDragOver.current = {
                        id: containerId[2],
                        time: time.utc().format("HH:mm"),
                        workstation: containerId[3]? containerId[3]: null
                    };

                    ghost.css("opacity", 1);
                } else {
                    ghostTime.html("Incorrect Slot");
                    //   ghostTime.empty();
                    sessionDragOver.current = null;
                }

        } else {
           // ghostTime.empty();
            ghostTime.html("Incorrect Slot");

            sessionDragOver.current = null;
        }

    }


    const handleGhostPointer = (event) => {
        if (admissionItemDnD) {

         //   console.log($("#dandd").position().top, event.pageY)

                const pageX = (event.pageX - 20) + "px";
                const pageY = (event.pageY) + "px";

                $(`#${admissionItemDnD.item.id}`).css("display","none");

                $("#dandd").css({
                    left: pageX,
                    top: pageY,
                    backgroundColor: "white",
                    borderRadius: "5px",
                    pointerEvents: "none",
                    display: "block",
                    opacity: 0.5,
                });

                $("#dandd_2").css({
                    left: pageX,
                    top: `${event.pageY - 30}px`,
                    backgroundColor: "#313233",
                    borderRadius: "5px",
                    //width: "60px",
                    height: "23px",
                    textAlign: "center",
                    display: "block"
                });

                let type = admissionType === admissionViewTypes.THEATRES? "day" : "workstation";
                setGhost(type, event);
            

        }
    };

    const handleRemoveGhostPointer = (e) => {
        if (admissionItemDnD) {

            $("#dandd").empty();
            $("#dandd_2").empty();
            $("#dandd_2").css("display", "none");

            $(`#${admissionItemDnD.item.id}`).css("display","block");

            if (sessionDragOver.current) {
                if(sessionDragOver.current.holdingPen) {
                    let data = {
                        theatreSessionId: sessionDragOver.current.id,
                        time: null,
                        operationId: admissionItemDnD.item.id,
                        workStationId: sessionDragOver.current.workstation,
                        opTimeLen: proceduresLen(admissionItemDnD.item),
                        holdingPen: true
                    }

                    dispatch(setAdmissionDnD(null));

                    API.theatreSessionsAddOperation(data).then(operations => {
                        dispatch(setMarkedOperation(null))
                        dispatch(reload());
                    }).catch(function (error) {
                        // TODO: error handler !!!
                        console.error(error);
                    });
                    sessionDragOver.current = null;
                } else {
                    if(admissionItemDnD.item.bookedSession && proceduresLen(admissionItemDnD.item) === 0) {
                        openEditOperationModal();
                        setOperationToEdit(admissionItemDnD.item);
                        setTimeIsValid(false);
                        dispatch(setAdmissionDnD(null));
                        sessionDragOverTmp.current = sessionDragOver.current;
                    } else {
                        let data = {
                            theatreSessionId: sessionDragOver.current.id,
                            time: sessionDragOver.current.time,
                            operationId: admissionItemDnD.item.id,
                            workStationId: sessionDragOver.current.workstation,
                            opTimeLen: proceduresLen(admissionItemDnD.item),
                            holdingPen: false
                        }

                        dispatch(setAdmissionDnD(null));

                        API.theatreSessionsAddOperation(data).then(operations => {
                            dispatch(setMarkedOperation(null))
                            dispatch(reload());
                        }).catch(function (error) {
                            // TODO: error handler !!!
                            console.error(error);
                        });
                        sessionDragOver.current = null;
                    }
                }


            } else {
                dispatch(setAdmissionDnD(null));
            }
            sessionDragOver.current = null;
        }
    };


    useEffect(() => {
        history.push(location.href, null);
        window.addEventListener("touchmove", prevDefault, {passive: false});
        window.addEventListener("pointermove", handleGhostPointer);
        window.addEventListener("pointerup", handleRemoveGhostPointer);
        return () => {
            window.removeEventListener("touchmove", prevDefault);
            window.removeEventListener("pointermove", handleGhostPointer);
            window.removeEventListener("pointerup", handleRemoveGhostPointer);

        };
    }, [admissionItemDnD, hourHeight]);

    const [procedures, setProcedures] = React.useState([]);
    const [operationToEdit, setOperationToEdit] = useState(null);
    const [isEditOperationModalOpen, openEditOperationModal, closeEditOperationModal] = useOpenState(false, true);
    const inputClasses =  useStylesInputControls();
    const classes = bookAdmissionToggleStyles();

    React.useEffect(()=> {
        let signalProcedures = new AbortController();
        dispatch(getSpecialties());
        API.getTheatres().then(theatres => {
                dispatch(setAllTheatersDict(theatres));
            })
            .catch(err => {
                console.error(err);

            })
            .finally(() => {
                // dispatch(setLoading(false));
            });

        API.getDictByURL("/$dict/Procedures", signalProcedures.signal).then(procedures => {
            setProcedures(procedures.__data);
        })
        return  ()=> {
            signalProcedures.abort();
        }

    },[]);

    const handleProcedureChange = (type, itemIdx, proc, time) => {
        switch(type) {
            case "update": {
                setOperationToEdit((ad)=>{
                    let proceduresTmp = ad.procedures? [...ad.procedures] : [];
                    proceduresTmp[itemIdx] = _.cloneDeep(proc)
                    return {
                        ...ad,
                        procedures: proceduresTmp
                    }
                });

                break;
            }
            case "update_time": {

                let maxTime = moment.utc(operationToEdit.sessiosObj.day).add(operationToEdit.sessiosObj.maxTime, "minutes");
                let splitTime = sessionDragOverTmp.current.time.split(":");

                let startTimeOfOperation = moment.utc(operationToEdit.sessiosObj.day).set({hour:splitTime[0],minute:splitTime[1],second:0,millisecond:0});
                let endTimeOfOperation = moment(startTimeOfOperation).add(time, "minutes");


                let sessions = operationToEdit.sessiosObj.bookedSessions.filter((op) => op.workStationId === sessionDragOverTmp.current.workstation);

                let isFree = true;

                if(isNaN(time) || !time) isFree = false;
                if(maxTime.isBefore(endTimeOfOperation)) isFree = false;

                sessions.forEach((ses)=>{
                    let startTime = moment.utc(ses.startTime);
                    let endTime = moment.utc(ses.startTime).add(ses.timeLen, "minutes");

                    if(!(endTimeOfOperation.isSameOrBefore(startTime) || startTimeOfOperation.isSameOrAfter(endTime))) {
                        isFree = false;
                    }
                })

                setTimeIsValid(isFree);

                setOperationToEdit((ad)=>{
                    let proceduresLenTmp = ad.proceduresLen? [...ad.proceduresLen] : [];
                    proceduresLenTmp[itemIdx] = time
                    return {
                        ...ad,
                        proceduresLen: proceduresLenTmp
                    }
                });
                break;
            }
            default: {

            }
        }
    }

    const [timeIsValid, setTimeIsValid] = useState(false);

    const saveOperation = async () => {

        let signalSubmit = new AbortController();

        let data = {
            theatreSessionId: operationToEdit.bookedSession,
            operationId: operationToEdit.id,
            opTimeLen: 0, // todo
            remove: true,
            cancelStatus: "rebook",
            comment: "rebook from reassign"
        }

        let remove = await API.theatreSessionsAddOperation(data);

        if(remove) {
            let filter = `_id eq_id '${operationToEdit.id}'`;
            let operationReq = await API.getOperation(filter);

            if(operationReq) {
                let tmpA = _.cloneDeep(operationReq[0]);

                delete tmpA["href"];
                delete tmpA["patient"];
                delete tmpA["type"];
                delete tmpA["sessiosObj"];


                if(tmpA.overseeingConsultant) {
                    tmpA.overseeingConsultant = {
                        id: tmpA.overseeingConsultant.id,
                        name: tmpA.overseeingConsultant.name,
                    }
                }

                tmpA.procedures = operationToEdit.procedures;
                tmpA.proceduresLen = operationToEdit.proceduresLen;
                tmpA.clinicalTeamNotes = operationToEdit.clinicalTeamNotes;

                let updateOperationReq = await API.admissionUpdate(tmpA, signalSubmit.signal);

                if(updateOperationReq) {
                    let data2 = {
                        theatreSessionId: sessionDragOverTmp.current.id,
                        time: sessionDragOverTmp.current.time,
                        operationId: updateOperationReq.id,
                        workStationId: sessionDragOverTmp.current.workstation,
                        opTimeLen: proceduresLen(updateOperationReq),
                    }

                    dispatch(setAdmissionDnD(null));

                    API.theatreSessionsAddOperation(data2).then(operations => {
                        closeEditOperationModal();
                        dispatch(setSnackbar({type: "success", message: "Operation assigned"}));
                        dispatch(setMarkedOperation(null))
                        dispatch(reload());
                    }).catch(function (error) {
                        // TODO: error handler !!!
                        dispatch(setSnackbar({type: "error", message: "Reassigned fail - updated operation on UNSCHEDULED LIST"}));
                        console.error(error);
                    });
                } else {
                    closeEditOperationModal();
                    dispatch(setSnackbar({type: "error", message: "Reassigned fail - operation on UNSCHEDULED LIST"}));
                }

            } else {
                closeEditOperationModal();
                dispatch(setSnackbar({type: "error", message: "Reassigned fail - operation on UNSCHEDULED LIST"}));
            }

        } else {
            closeEditOperationModal();
            dispatch(setSnackbar({type: "error", message: "Reassigned fail (R)"}));
        }


    }


    const handleChange = (field, value) => {
        setOperationToEdit((ad)=>{
            return {
                ...ad,
                clinicalTeamNotes: {
                    ...ad.clinicalTeamNotes,
                    [field]: value
                }
            }

        });

    }

    const renderReassignedInfoModal = () => {
        return  <AgyleDialog
            title={"Fill in the Basic Information"}
            open={isEditOperationModalOpen}
            onClose={closeEditOperationModal}
            width={"lg"}
            contentStyle={classes.dialogContentStyle}
            disableActions
            closeButtonOnHeader
        >
            <div>
                <FormControl sx={{width: "100%", marginLeft: "10px"}}>
                    <FormLabel id="op-notes-label" className={inputClasses.label}>Notes</FormLabel>
                    <AgyleTextField
                        className={inputClasses.notesInputModal}
                        aria-label="Notes"
                        value={operationToEdit?.clinicalTeamNotes?.notes}
                        maxRows={10}
                        onChange={(ev)=> {handleChange('notes', ev.target.value)}}
                        minRows={5}
                        multiline
                    />
                </FormControl>
                <div>
                    {operationToEdit && <ProcedureItem index={0}
                                                       procedureMDU
                                                       isBooked = {false}
                                                       disabled={false}
                                                       procedureItem={operationToEdit.procedures[0]}
                                                       procedure={operationToEdit.procedures} procedureLen={operationToEdit.proceduresLen}
                                                       proceduresDict={procedures} systype={operationToEdit.opType} consultant={operationToEdit.consultant?.__id}
                                                       onChange={handleProcedureChange}/>
                    }
                </div>
                <div>
                    <AgyleButton
                        style={{width: "100%"}}
                        variant={"contained"}
                        disabled={!timeIsValid}
                        onClick={saveOperation}
                    >
                        Save
                    </AgyleButton>
                </div>
            </div>

        </AgyleDialog>
    }
    return(<div style={{margin: 10}}>

        {renderReassignedInfoModal()}

        <BookedAdmissionsHeader goToMain={isCentralPageModuleEnabled && !props?.isFrame} isFrame={props.isFrame}/>

        { admissionStatus === admissionStatusTypes.WORKLIST &&  <WorkList admissionStatus={admissionStatus}/>}
        { admissionStatus !== admissionStatusTypes.WORKLIST &&
            <div style={{display: "flex"}}>
                <PatientsList proceduresDict={procedures}/>
                <AdmissionContent/>
            </div>
        }

    </div>)
};

export default BookedAdmissions